import PropTypes from "prop-types";
import React, { Component } from "react";
import ButtonBase from '@material-ui/core/ButtonBase';
import {Container, Text} from "../../../../../components/index";
import {di} from "../../../../../bottle";
import TweenMax from "gsap/TweenMaxBase";
import { Transition } from "react-transition-group";

// class definition
export class Controls extends Component {

    static propTypes = {
        canCustomize: PropTypes.bool,
        onPressColor: PropTypes.func.isRequired,
        onPressBuild: PropTypes.func.isRequired,
        onPressReset: PropTypes.func.isRequired,
    };

    static defaultProps = {
        canCustomize: true,
        onPressColor: () => undefined,
        onPressBuild: () => undefined,
        onPressReset: () => undefined,
    };

    render() {

        // resolve input
        const {
            onPressColor,
            onPressBuild,
            onPressReset
        } = this.props;

        const {localization} = di;

        // render view
        return (
            <Container style={styles.container} flex touchless>
                <Container flex touchless>
                    <ButtonBase onClick={onPressReset} style={styles.buttonContainer}>
                        <Container flex alignItems="center" justify="space-between">
                            <img style={styles.resetIcon} src={require("../assets/Restart.png")}/>
                            <Text style={styles.buttonText} bold uppercase>
                                {localization.get("build.buttons.restart")}
                            </Text>
                        </Container>
                    </ButtonBase>

                    <Transition
                        timeout={1}
                        appear
                        mountOnEnter
                        unmountOnExit
                        in={this.props.canCustomize}
                        onEntering={(node, isAppearing) => {
                            this.animator = TweenMax.from(node, 0.7, {
                                autoAlpha: 0,
                                y: "-=50",
                                onReverseComplete: () => {
                                    console.log("[] reverse complete")
                                }
                            })
                        }}>
                        <Container flex touchless justify="center" style={{marginTop: -200}}>
                            <ButtonBase onClick={onPressColor} style={styles.buttonContainer}>
                                <Container flex alignItems="center" justify="space-between">
                                    <Container justify="center" alignItems="center" style={styles.button}>
                                        <img style={styles.icon} src={require("../assets/sprayCanIcon@3x.png")} />
                                    </Container>
                                    <Text style={styles.buttonText} bold uppercase >
                                        {localization.get("build.buttons.color")}
                                    </Text>
                                </Container>
                            </ButtonBase>

                            <ButtonBase onClick={onPressBuild} style={styles.buttonContainer}>
                                <Container flex alignItems="center" justify="space-between">
                                    <Container justify="center" alignItems="center" style={styles.button}>
                                        <img style={styles.icon} src={require("../assets/buildIcon@3x.png")}/>
                                    </Container>
                                    <Text style={styles.buttonText} bold uppercase>
                                        {localization.get("build.buttons.build")}
                                    </Text>
                                </Container>
                            </ButtonBase>
                        </Container>
                    </Transition>
                </Container>
            </Container>
        );
    }
}

const styles = {
    container: {
        position: "absolute",
        right: 0,
        backgroundColor: "transparent",
        paddingTop: 115,
        height: "inherit",
        paddingRight: 25
    },
    buttonContainer: {
        backgroundColor: "transparent",
        padding: 10
    },
    button: {
        display: "flex",
        minWidth: 60,
        width: 77,
        height: 77,
        margin: 10,
        marginBottom: 7,
        border: "solid",
        borderRadius: 77 / 2,
        borderWidth: 1,
        borderColor: "rgb(255, 210, 0)",
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(43, 43, 43, 0.5)',
        shadowColor: 'rgb(0, 0, 0)',
        shadowOpacity: 0.25,
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 8,
    },
    resetIcon: {
        width: 77,
        height: 77,
    },
    icon: {
        height: 38,
    },
    buttonText: {
        textShadow: "0 1 px 1px rgba(0, 0, 0, 0.35)",
        fontSize: 25,
        textAlign: "center",
        color: "#ffffff",
        marginTop: 5
    },
};




// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Controls.js